import { create } from 'zustand'
import { useVisibilityStore } from './useVisibilityStore'
import { EpgDay, ExtendedEpgElement } from '@/types/epg/Epg'
import Program from '@/shared/classes/epg/program/program'

export interface EPGState {
    epgData: ExtendedEpgElement[]
    programToScroll: Program | null
    isEpgContentVisible: boolean
    dayTime: string
    day: EpgDay
    filterDays: EpgDay[]
    isEpgDataFetching: boolean

    setEpg: (preparedEpg: ExtendedEpgElement[]) => void
    setEpgContentVisible: () => void
    setDayTime: (newDayTime: string) => void
    setDay: (newDay: EpgDay) => void
    setFilterDays: (newFilterDays: EpgDay[]) => void
    setIsEpgDataFetching: (isEpgDataFetching: boolean) => void
    clearEpgStore: () => void
    setProgramToScroll: (program: Program | null) => void
}

export const useEPGStore = create<EPGState>()((set) => ({
    epgData: [],
    programToScroll: null,
    isEpgContentVisible: false,
    dayTime: '',
    day: { dayName: '', dayNumber: 0, date: '' },
    filterDays: [],
    isUserScrollEvent: false,
    isEpgDataFetching: false,

    setEpgContentVisible: () => {
        const { setEpgContentVisible } = useVisibilityStore.getState()
        setEpgContentVisible()
    },

    setEpg: async (preparedEpg: ExtendedEpgElement[]) => {
        set(() => ({ epgData: preparedEpg }))
    },
    setDayTime: (newDayTime: string) => {
        set(() => ({ dayTime: newDayTime }))
    },
    setDay: (newDay: EpgDay) => {
        set(() => ({ day: newDay }))
    },
    setFilterDays: (newFilterDays: EpgDay[]) => {
        set(() => ({ filterDays: newFilterDays }))
    },
    setIsEpgDataFetching: (isEpgDataFetching: boolean) => {
        set(() => ({ isEpgDataFetching }))
    },

    setProgramToScroll: (program: Program | null) => {
        set(() => ({
            programToScroll: program,
        }))
    },
    clearEpgStore: () => {
        set(() => ({
            epgData: [],
            isEpgContentVisible: false,
            dayTime: '',
            day: { dayName: '', dayNumber: 0, date: '' },
            filterDays: [],
        }))
    },
}))
